
import { Injectable } from '@angular/core';
import { ApplicationsReceivedModel } from '@apply4u/Models/application-received-card';
import { SavedSearchStats } from '@apply4u/Models/auto-save-search';
import { JobAppliedStats } from '@apply4u/Models/jobs-applied-stats';
import { RecentSearchesModel } from '@apply4u/Models/recent-searches-dashboard';
import { CVDownload } from '@apply4u/features/dashboard/models/cv-download';
import { CVViews } from '@apply4u/features/dashboard/models/cv-views';
import { JobViews } from '@apply4u/features/dashboard/models/job-views';
import { DashboardFeeds } from '@apply4u/models';
import { KeyValue } from '@apply4u/models/common/key-value-pair';
import { Cvsearch4urequest } from '@apply4u/models/cvsearch4urequest';
import { JobseekerDashboardStats, RecruiterDashboardStats } from '@apply4u/models/jobseeker-dashboard-stats';
import { ProfileProgress } from '@apply4u/models/profileProgress';
import { Observable } from 'rxjs';
import { Dashboard } from '../models/dashboard';
import { UserRestrictedFeed } from '../models/user-restricted-feed';
import { UserAchivedBadges } from '../models/userAchivedBadges';
import { UserBadges } from '../models/userBadges';
import { HttpClientWrapper } from './httpclientwrapper';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClientWrapper) { }


  GetUserDashboardFeedsByUserId(userId: number, pageNumber: number, pageSize: number): Observable<DashboardFeeds[]> {
    return this.http.GetAsync<DashboardFeeds[]>(this.http.BaseUrl + "api/Dashboard/feeds?userId=" + userId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
  }

  GetDataForDashboard(userId: number): Observable<Dashboard> {
    return this.http.GetAsync<Dashboard>(this.http.BaseUrl + "api/Dashboard/info?userId=" + userId);
  }

  DeleteFeed(Id: any): Observable<any> {

    return this.http.DeleteAsync<any>(this.http.BaseUrl + "api/Feeds/feedId?feedId=" + Id);
  }

  SaveUserRestrictedFeed(userRestrictedFeed: UserRestrictedFeed) {
    return this.http.PostAsync(this.http.BaseUrl + "api/UserRestrictedFeeds", userRestrictedFeed);
  }

  GetNotifications(userId: number, pageNumber: number, pageSize: number): Observable<DashboardFeeds[]> {

    return this.http.GetAsync<DashboardFeeds[]>(this.http.BaseUrl + "api/Feeds/search?userId=" + userId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
  }

  MarkViewedNotification(feedId: number): Observable<any> {

    return this.http.PutAsync<any>(this.http.BaseUrl + "api/Feeds/MarkViewed?feedId=" + feedId, null);
  }


  GetNotificationCount(userId: number): Observable<number> {
    return this.http.GetAsync<number>(this.http.BaseUrl + "api/Feeds/counts?userId=" + userId);
  }

  GetMessageNotificationCount(receiverId: number): Observable<number> {
    return this.http.GetAsync<number>(this.http.TransmitterApiBaseUrl + `api/User/${receiverId}/UserMessage/NotificationsCount` + "?stamp=" + new Date().getTime());
  }

  GetMessageNotifications(receiverId: number): Observable<KeyValue<number, KeyValue<number, Date>>[]> {
    return this.http.GetAsync<KeyValue<number, KeyValue<number, Date>>[]>(this.http.TransmitterApiBaseUrl + `api/User/${receiverId}/UserMessage/Notifications` + "?stamp=" + new Date().getTime());
  }

  GetTotalFeedCounts(userId: number): Observable<number> {

    return this.http.GetAsync<number>(this.http.BaseUrl + "api/Feeds/TotalFeedCounts?userId=" + userId);
  }

  SaveNewFeed(feed: DashboardFeeds): Observable<any> {

    return this.http.PostAsync(this.http.BaseUrl + "api/Feeds", feed);
  }

  //dashboardTypeId = 1 Candidate   DashboardType Joobseeker
  //dashboardTypeId = 2 Recruiter   DashboardType Recruiter
  GetUserProfileProgressbar(loggedInUserId: number, dashboardTypeId: number): Observable<number> {

    return this.http.GetAsync<number>(this.http.BaseUrl + "api/UserProfiles/userprogress?loggedInUserId=" + loggedInUserId + "&dashboardTypeId=" + dashboardTypeId);
  }

  GetUserBadges(userId: number): Observable<UserBadges[]> {
    return this.http.GetAsync<UserBadges[]>(this.http.BaseUrl + "api/UserBadge/GetUserBadgeAsync?userId=" + userId);
  }

  GetUserAchivedBadges(userId: number, badgeTypeId: number): Observable<UserAchivedBadges[]> {

    return this.http.GetAsync<UserAchivedBadges[]>(this.http.BaseUrl + "api/UserBadge/badgesInfo?userId=" + userId + "&badgeTypeId=" + badgeTypeId);
  }

  GetUserRecentBadges(loggedInUserId: number): Observable<UserBadges[]> {
    return this.http.GetAsync<UserBadges[]>(this.http.BaseUrl + "api/Dashboard/recentBadges?loggedInUserId=" + loggedInUserId);
  }

  GetUserRecentBadgesDetail(loggedInUserId: number): Observable<UserBadges[]> {
    // this API should return data for Recently awarded Badges to the user and display PopUp 
    return this.http.GetAsync<UserBadges[]>(this.http.BaseUrl + "api/Dashboard/recentBadgesDetail?loggedInUserId=" + loggedInUserId);
  }

  UpdateUserRecentBadgesDetail(userBadgeIds: any, userBadgeObject: any): Observable<any> {

    return this.http.PutAsync(this.http.BaseUrl + "api/Dashboard/updateRecentBadgesDetail?userBadgeIds=" + userBadgeIds, userBadgeObject);
  }

  UpdateUserSelectedBadgeToDisplay(loggedInUserId: number, badgeId: number): Observable<any> {

    return this.http.PutAsync(this.http.BaseUrl + "api/UserBadge/updateUserDefaultBadge?loggedInUserId=" + loggedInUserId + "&badgeId=" + badgeId, null);
  }

  GetMessagesNotifications(userId: number, feedTypeId: number): Observable<DashboardFeeds[]> {
    return this.http.GetAsync<DashboardFeeds[]>(this.http.BaseUrl + "api/Feeds/SearchFeedsByType?userId=" + userId + "&feedTypeId=" + feedTypeId);
  }

  MarkFeedTypeAsViewed(userId: number, participatedById: number, feedTypeId: number): Observable<any> {
    return this.http.PutAsync<any>(this.http.BaseUrl + "api/Feeds/MarkFeedTypeAsViewed?userId=" + userId + "&participatedById=" + participatedById + "&feedTypeId=" + feedTypeId, null);
  }

  GetDashboardStatsForJobseeker(userId: number): Observable<JobseekerDashboardStats> {
    return this.http.GetAsync<JobseekerDashboardStats>(this.http.BaseUrl + "api/Dashboard/Candidate?userId=" + userId);
  }

  GetDashboardStatsForRecruiter(userId: number): Observable<RecruiterDashboardStats> {
    return this.http.GetAsync<RecruiterDashboardStats>(this.http.BaseUrl + "api/Dashboard/recruiter?userId=" + userId);
  }

  GetUserProfileProgressDetail(loggedInUserId: number, dashboardTypeId: number): Observable<ProfileProgress[]> {

    return this.http.GetAsync<ProfileProgress[]>(this.http.BaseUrl + "api/UserProfiles/userprogressDetail?loggedInUserId=" + loggedInUserId + "&dashboardTypeId=" + dashboardTypeId);
  }

  GetUserFeedCount(userId: number): Observable<number> {
    return this.http.GetAsync<number>(this.http.BaseUrl + "api/Dashboard/UserFeedCount?userId=" + userId);
  }

  GetJobseekerCVDownloadStats(userId: number, pageNumber: number, pageSize: number): Observable<CVDownload[]> {
    return this.http.GetAsync<CVDownload[]>(this.http.BaseUrl + "api/UserStatistics/CvDownloadsForJobseeker?userId=" + userId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
  }

  GetJobseekerCVViewsStats(userId: number, pageNumber: number, pageSize: number): Observable<CVViews[]> {
    return this.http.GetAsync<CVViews[]>(this.http.BaseUrl + "api/UserStatistics/CvViewsForJobseeker?userId=" + userId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
  }

  GetJobseekerProfileViewsStats(userId: number, pageNumber: number, pageSize: number): Observable<CVViews[]> {
    return this.http.GetAsync<CVViews[]>(this.http.BaseUrl + "api/UserStatistics/ProfileViewsForJobseeker?userId=" + userId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
  }

  GetRecruiterCVDownloadStats(userId: number, pageNumber: number, pageSize: number): Observable<CVDownload[]> {
    return this.http.GetAsync<CVDownload[]>(this.http.BaseUrl + "api/UserStatistics/CvDownloadsForRecruiter?userId=" + userId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
  }

  GetRecruiterJobViewsStats(userId: number, pageNumber: number, pageSize: number): Observable<JobViews[]> {
    return this.http.GetAsync<JobViews[]>(this.http.BaseUrl + "api/UserStatistics/JobViewsForRecruiter?userId=" + userId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
  }

  GetCVSearch4uRequestsByUserId(userId: number): Observable<Cvsearch4urequest[]> {
    return this.http.GetAsync<Cvsearch4urequest[]>(this.http.BaseUrl + "api/Dashboard/GetCvSearchRequestsByUserId?userId=" + userId);
  }

  GetApplicationsReceivedByUserId(userId: number): Observable<ApplicationsReceivedModel[]> {
    return this.http.GetAsync<ApplicationsReceivedModel[]>(this.http.BaseUrl + "api/Dashboard/GetApplicationsReceivedByUserId?userId=" + userId);
  }

  GetRecentSearchesByUserId(userId: number, isJobSeeker:boolean): Observable<RecentSearchesModel[]> {
    return this.http.GetAsync<RecentSearchesModel[]>(this.http.BaseUrl + "api/Dashboard/GetRecentSearchesByUserId?userId=" + userId + "&isJobSearch=" + isJobSeeker);
  }

  GetJobSearch(userId: number): Observable<JobAppliedStats[]> {
    return this.http.GetAsync<JobAppliedStats[]>(this.http.BaseUrl + "api/Dashboard/GetJobSearch?userId=" + userId);
  }

  GetRecruiterSavedSearchesByUserId(userId: number): Observable<SavedSearchStats[]> {
    return this.http.GetAsync<SavedSearchStats[]>(this.http.BaseUrl + "api/Dashboard/autosearch/recruiter?userId=" + userId);
  }

  GetCandidateSavedSearchesByUserId(userId: number): Observable<SavedSearchStats> {
    return this.http.GetAsync<SavedSearchStats>(this.http.BaseUrl + "api/Dashboard/autosearch/candidate?userId=" + userId);
  }

}

